import { render } from "./DragAndDropMixins.vue?vue&type=template&id=4f48f6e5"
import script from "./DragAndDropMixins.vue?vue&type=script&lang=js"
export * from "./DragAndDropMixins.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__